import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './logo.svg';
import logoMin from './logoMin.svg';
import { useLanguage } from './useLanguage';
import { posts } from './BlogPost';

const BlogList = () => {
  const { lang, t } = useLanguage();

  useEffect(() => {
    const title = lang === 'no' ? 'Blogg | Flow Lab' : 'Blog | Flow Lab';
    const description = lang === 'no'
      ? 'Les våre siste artikler om AI, maskinlæring og automatisering.'
      : 'Read our latest articles on AI, machine learning, and automation.';
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.content = description;
    window.scrollTo(0, 0);
  }, [lang]);

  const homeHref = lang === 'no' ? '/' : '/en/';

  return (
    <>
      <header className="blog-header">
        <Link to={homeHref} className="logo-link" aria-label="Flow Lab">
          <img src={logo} alt="Flow Lab" className="top-left-logo logo-desktop" width="150" height="45" />
          <img src={logoMin} alt="Flow Lab" className="top-left-logo logo-mobile" width="150" height="45" />
        </Link>
        <nav className="lang-switcher">
          <Link
            to="/blogg"
            className={lang === 'no' ? 'active' : ''}
            onClick={() => localStorage.setItem('lang-preference', 'no')}
          >
            NO
          </Link>
          <span className="lang-divider">|</span>
          <Link
            to="/en/blog"
            className={lang === 'en' ? 'active' : ''}
            onClick={() => localStorage.setItem('lang-preference', 'en')}
          >
            EN
          </Link>
        </nav>
      </header>

      <section className="blog-list">
        <div className="section-inner">
          <h1>{t('nav.blog')}</h1>
          <div className="blog-list-cards">
            {posts.map((post) => {
              const c = post[lang];
              const slug = post.slugs[lang];
              const url = lang === 'no' ? `/blogg/${slug}` : `/en/blog/${slug}`;
              return (
                <Link to={url} className="blog-card" key={slug}>
                  <time className="blog-card-date" dateTime={post.dateISO}>{c.date}</time>
                  <h3>{c.title}</h3>
                  <p>{c.excerpt}</p>
                  <span className="blog-read-more">{t('blog.readMore')}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogList;
